// removed by extract-text-webpack-plugin
module.exports = {"bg":"#ffffff","shadow":"0px 2px 6px 0px rgba(16, 37, 79, 0.1)","menuBg":"#ffffff","menuText":"#303133","menuActiveText":"#ffffff"};


//////////////////
// WEBPACK FOOTER
// ./src/style/common.scss
// module id = WWTk
// module chunks = 51